/* eslint-disable */
import React from "react";
import { useRouter } from "next/router";
import { Modal } from "@aqar-app/react-ui";
import { SpacesModal } from "@/components/Listing/ListingScreen/spacesModal";
import { trackClickToPublish } from "@/lib/tracking/trackMonthlyAd";
import { usePath } from "@/contexts/path/path";

export const Spinner = () => null;
export const RENT_PERIOD_MAP = { 1: "يومي", 2: "شهري", 3: "سنوي" };
export const CLOSED_STATUS_MAP = {
  1: 1,
  2: 2,
  3: 3,
  5: 5,
  6: 6,
};

export function getOnClick(action, router) {
  if (action === "ADD_LISTING")
    return () => {
      router.push("/add-listing/init/category");
    };
  if (action === "REGA_WEBSITE")
    return () => {
      // eslint-disable-next-line no-restricted-globals
      open("https://aqr.to/rega-eservices");
    };
  if (action === "SUBSCRIPTIONS_SCREEN")
    return () => {
      router.push("/payment-gateway/pricing-packages");
    };
  if (action === "FEES_SCREEN")
    return () => {
      router.push("/services");
    };
  if (action === "CUSTOMER_SUPPORT")
    return () => {
      router.push(encodeURIComponent("/تواصل-معنا#support"));
    };
  if (action === "CUSTOMER_SUPPORT_WA")
    return () => {
      // eslint-disable-next-line no-restricted-globals
      open(" https://aqr.to/support");
    };

  return () => {};
}

export function Alert({
  next_action,
  background_color,
  border_color,
  text_color,
  msg_ar,
  ...props
}) {
  const router = useRouter();
  return (
    <div
      onClick={getOnClick(next_action, router)}
      style={{
        padding: ".5rem 1rem",
        whiteSpace: "pre-line",
        margin: ".5rem 0",
        borderRadius: ".3rem",
        background: background_color,
        border: `1px solid ${border_color}`,
        color: text_color,
        cursor: `${(next_action && "pointer") || undefined}`,
      }}
      {...props}
    >
      {msg_ar}
    </div>
  );
}

export function AlertForUser({ user, alert_box, listingUserId } = {}) {
  if (!alert_box) return null;

  const { for_searcher, for_listing_owner, for_subscriber } = alert_box;

  if (!user) return <Alert {...for_searcher} />;

  if (
    alert_box.for_listing_owner &&
    alert_box.for_listing_owner.show &&
    listingUserId === user.user_id
  )
    return <Alert {...for_listing_owner} />;

  if (listingUserId !== user.user_id && for_subscriber && user.paid)
    return <Alert {...for_subscriber} />;

  if (listingUserId !== user.user_id && for_searcher)
    return <Alert {...for_searcher} />;
  return null;
}

export function SpaceAlert({ alert: alert_box, space, listing } = {}) {
  const { previousPath, categoriesDictionary } = usePath();
  if (!alert_box) return null;

  return (
    <Alert
      onClick={(e) => {
        if (alert_box.next_action === "SHOW_POPUP") {
          trackClickToPublish({
            source: previousPath || decodeURI(document.referrer),
            listing,
            categoriesDictionary,
          });
          Modal.open(<SpacesModal space={space} />)(e);
        }
      }}
      {...alert_box}
    />
  );
}
